export default "__VITE_ASSET__lFi9ieo8__"